<app-banner-app [retroSelected]="true"></app-banner-app>
<br><br><br>

<!-- Timelines -->
<div class="visibilidadDiv">
    <div class="container" style="width: 700px;">
        <div class="row">
            <div class="col">
                <br><br><br><br>
                <div id="stepper1" class="bs-stepper">
                    <div class="bs-stepper-header" style="text-align: center;">
                        <div class="step" data-target="#test-l-1">
                            <div>
                                <div>
                                    <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                                            fill="currentColor" class="bi bi-check-lg" viewBox="0 0 16 16">
                                            <path
                                                d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                        </svg>
                                    </span>
                                </div>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Firma contrato</span>
                            </div>

                        </div>

                        <div class="line" style="height: 2px; margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-2">
                            <div>
                                <span class="bs-stepper-circle estiloTextoNum" style="background-color: #00AEC7;">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor"
                                        class="bi bi-check-lg" viewBox="0 0 16 16">
                                        <path
                                            d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425z" />
                                    </svg>
                                </span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Validación identidad</span>
                            </div>
                        </div>

                        <div class="line" style="height: 2px;  margin-bottom: 50px;"></div>
                        <div class="step" data-target="#test-l-3">
                            <div>
                                <span class="standby bs-stepper-circle estiloTextoNum"
                                style="background-color: #2D6DF6;">3</span>
                            </div>
                            <div>
                                <span class="bs-stepper-label estiloTextoStepper">Resúmen</span>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <br><br>
</div>

<!-- Progress Bar -->
<div class="container contenedorProgressBar">
    <div class="row">
        <div class="col">
            <strong>
                <p class="progressBarActivo">Resúmen</p>
            </strong>
        </div>
    </div>
    <ngb-progressbar class="mb-3" type="primary" [value]="100" height=".5rem">
    </ngb-progressbar>
</div>


<div class="container" style="width: 80%;">
    <app-messages *ngIf=swAlerta [mensajeComponente]="mensajeAlerta"></app-messages>
    <br>
</div>

<div class="container">
    <div class="row">
        <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0">
            <div class="aliniacionTexto">
                <span class="pagina__texto-principal">Este es el resumen de tu compra</span>
                <div class="desktop"><br><br></div>
                <br><br>
            </div>
            
            <div class="visibilidadDiv" style=" text-align: center;">
                <img class="styleImage" src="./assets/img/Redirección_1080x1080.png" />
                <br><br>
            </div>
        </div>

        <div class="col">
            <div class="card card__sombreado-propio">
                <div class="card-header estiloCardBanner">
                    <div class="container">
                        <div class="row" style="padding-top: 5px; padding-bottom: 7px;">
                            <div class="col">
                                <div class="estiloTextoBanner">
                                    <div class="banner__Texto-titulo">Plan {{ resumenCompra.Plan }}</div>
                                    <div style="width: 100%">
                                        <span class="banner__Texto-direccion">Dirección: </span>
                                        <span class="banner__Direccion">{{ resumenCompra.Direccion }}</span>
                                    </div>
                                </div>
                            </div>
                            <img name="logo" class="img-responsive" src="./assets/img/Capa_1-2-Logo.svg"
                                style="width: 30%;">
                        </div>
                    </div>
                </div>

                <div class="card-body" style="margin-left: 30px; margin-right: 30px;">
                    <h5 class="card-title textoInicial">Dueño:</h5>
                    <div class="row datos__Comprador">
                        <div class="col" style="text-align: right;">
                            <p class="card-text">C.C. {{ resumenCompra.Identificacion }}</p>
                        </div>
                    </div>
                    <p class="card-text datos__Comprador">{{ resumenCompra.Ciudad }}</p>
                    <hr>
                    <div class="div-card__Coberturas">Coberturas:</div>
                    <br>
                    <ul style="list-style-image:url(./assets/img/cheque.png);">
                        <li>
                            <div class="estiloViñetas">Canon de arrendamiento</div>
                        </li>
                        <li>
                            <div class="estiloViñetas">Cuota de administración</div>
                        </li>
                        <li>
                            <div class="estiloViñetas">Servicios públicos</div>
                        </li>
                        <li>
                            <div class="estiloViñetas">Paquete de asistencia básica</div>
                        </li>
                    </ul>
                    <hr>

                    <div style="width: 100%; height: 100%">
                        <span class="seccion-dos__texto-superior">
                            Fecha de inicio del contrato de arrendamiento<br />
                        </span>
                        <span class="seccion-dos__texto-inferior">
                            {{ resumenCompra.FechaContrato }}
                        </span>
                    </div>
                    <hr>
                    <br>

                    <div class="container">
                        <div class="row">
                            <div class="col-sm-6 col-md-2 offset-md-2 col-lg-6 offset-lg-0">
                                <div class="seccion-total__Titulo">Pago total:</div>
                            </div>
                            <div class="col-sm-6 col-md-5 offset-md-2 col-lg-6 offset-lg-0" style="text-align: right;">
                                <div class="seccion-total__Valor">{{ resumenCompra.PagoTotal }}</div>
                            </div>
                        </div>
                    </div>
                    <br>
                </div>
            </div>
            <br><br>

            <div style="width: 50%;" class="container">
                <button class="btn btn-primary w-100 py-2 botonContinuar" type="submit" (click)="pagar()">Pagar</button>
            </div>
        </div>
    </div>
</div>

<br><br><br>
<app-footer-app></app-footer-app>